module.exports = __webpack_public_path__ + "img/big_ico_level@3x.57ae27b2.png";